<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body v-if="reservation">
      <b-row>
        <b-col lg="4">
          <p><strong>Comments:</strong></p>
          <p>
            {{ reservation.comments }}
          </p>
        </b-col>
        <b-col lg="8">
          <p><strong>Prefered Accommodation:</strong></p>
          <b-list-group>
            <b-list-group-item>Accomodation Type: {{ reservation.accomodation_type }}</b-list-group-item>
            <b-list-group-item>Toilet Type: {{ reservation.toilet_type }}</b-list-group-item>
            <b-list-group-item>AC Room: {{ reservation.ac_room }}</b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
      <b-form-group label="Number of Rooms" label-for="numberOfRooms" label-cols-sm="4" label-cols-lg="3">
        <b-form-input id="numberOfRooms" type="number" placeholder="Please choose the number of rooms" @change="changeNumberOfRooms" />
      </b-form-group>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
      <strong>Available buildings</strong>
      <b-row>
        <b-col lg="12">
          <building-auto-search :reservation="reservation" ref="buildingAutoSearch" @selected="selectBuilding"></building-auto-search>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

</div>
</template>

<script>
import BuildingAutoSearch from './BuildingAutoSearch'
import {
  mapState,
} from 'vuex'

export default {
  name: "SingleAutoMatching",
  props: {
    reservation: Object
  },
  components: {
    BuildingAutoSearch,
  },
  data() {
    return {
      numberOfRooms: 1
    }
  },
  methods: {
    changeNumberOfRooms(number) {
      this.numberOfRooms = number
      this.$refs.buildingAutoSearch.setNumberOfRooms(number)
    },
    selectBuilding(buildingId) {
      let selectedIds = _.map(this.selectedRooms, room => room.id)
      this.$store.dispatch('reservations/setAutoRooms', {id: this.reservation.id, building_id: buildingId, number_of_rooms: parseInt(this.numberOfRooms)})
      .then(() => {
        this.$emit('change')
        this.showSuccessMsg()
      })
      .catch((error) => {
        if (error.response.status == 400) {
          this.showErrorMsg({
            message: error.response.data.message
          })
        } else {
          this.showErrorMsg()
        }
      })
    }
  },
  created() {
    this.changeNumberOfRooms(1);
  }
}
</script>
